import { Element, Icon } from '@zmedia/bm-soccer-ui/components';
import { AuthUtils, Logger } from '@zmedia/bm-soccer-ui/utils';
import useAuth from '@zmedia/bm-soccer-ui/hooks/useAuth';
import styles from './styles.module.scss';
import CookieStore from '@zmedia/bm-soccer-ui/utils/cookie';
import { COOKIE_KEY } from '@zmedia/bm-soccer-ui/constants';

const ZaloLoginButton = ({ textButton = 'Zalo' }) => {
    const { auth } = useAuth();
    const handleLogin = () => {
        Logger.debug('on login');
        (window as any).ZA?.handleCookieConsentGranted();
        CookieStore.set(COOKIE_KEY.BM_CLICK_LOGIN, true);
        AuthUtils.login(auth);
    };
    return (
        <Element
            renderAs="button"
            className={styles['btn-zalo']}
            onClick={handleLogin}
            title='Đăng nhập'
        >
            <Icon type="bm" icon="zalo"></Icon>
            <span>{textButton}</span>
        </Element>
    );
};

export default ZaloLoginButton;
